import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ContactRequestService} from "../../../../service/api/contact-request.service";
import {ContactRequestResponseModel} from "../../../../shared/model/response/event/contactRequestResponse.model";
import {ApiResponse} from "../../../../shared/model/response/ApiResponse";
import {MessageToastService} from "../../../../service/message-toast.service";
import {finalize} from "rxjs";

@Component({
    selector: 'app-contactrequest',
    templateUrl: './contactrequest.component.html',
    standalone: false
})
export class ContactrequestComponent implements OnInit {


  loading: boolean = false;
  public isShow: boolean;
  public isLoadedOnce: boolean
  public isLoadedOnceRetuned: boolean

  public contactRequest: ContactRequestResponseModel

  @Input('eventId') eventId: number

  form: FormGroup;
  apiErrors: Map<string, string> = new Map<string, string>()


  constructor(private contactRequestService: ContactRequestService,
              private toastMessageService: MessageToastService) {
    this.isLoadedOnce = false
  }

  ngOnInit(): void {
    this.initForm()
  }

  //initialize the form
  initForm() {
    this.form = new FormGroup({"message": new FormControl(null, [Validators.required])});
  }


  loadDialog() {
    this.isShow = true
    if (!this.isLoadedOnce) {
      this.loadContactRequest(this.eventId)
      this.isLoadedOnce = true
    }
  }

  //save the contactRequest.
  saveContactRequest() {

    this.loading = true
    this.apiErrors.clear()

    this.contactRequestService.createContactRequest(this.form.value, this.eventId)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
      next: (response: ApiResponse<ContactRequestResponseModel>) => {
        this.contactRequest = response.data
        this.form.get("message").disable()
        this.toastMessageService.success(response.message)
      },
      error: (apiError: ApiResponse<any>) => {
        this.apiErrors = apiError?.formErrors ?? new Map()
        this.toastMessageService.error(apiError?.message)
      }
    });
  }

  //remove the contactRequest.
  onRemoveContactRequest() {
    this.loading = true
    this.apiErrors.clear()

    this.contactRequestService.removeContactRequest(this.contactRequest.id)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
      next: (response: ApiResponse<ContactRequestResponseModel>) => {
        this.contactRequest = null
        this.form.reset()
        this.isLoadedOnceRetuned = true
        this.form.get("message").enable()
        this.toastMessageService.success(response.message)
      },
      error: (apiError: ApiResponse<any>) => {
        this.isLoadedOnceRetuned = true
        this.toastMessageService.error(apiError?.message)
      }
    })

  }

//load the contactRequest
  loadContactRequest(eventId: number) {
    this.loading = true

    this.contactRequestService.getEventUserContactRequest(eventId)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
      next: (response: ApiResponse<ContactRequestResponseModel>) => {
        this.contactRequest = response.data
        this.form.get("message").setValue(response.data.message)
        this.form.get("message").disable()
        this.isLoadedOnceRetuned = true
      },
      error: () => {
        this.isLoadedOnceRetuned = true
      }
    });
  }
}
